module.exports = __webpack_public_path__ + "img/Anhänger_NEA_650kVA.bd64570d.svg";